import React, { useState } from "react";
import { useForm } from "react-hook-form";
import BackDrop from "../../../components/ui/BackDrop";
import { cn } from "../../../utils/twMerge";
import { z } from "zod";
import { zodResolver } from "@hookform/resolvers/zod";

import { datePickerIcon, closeIcon } from "../../../assetData/icons";
import CustomDateInput from "../../../components/ui/custom-date-input/CustomDateInput";
import MirageLoader from "../../../components/ui/pageLoader/MirageLoader";

const MasterPriceAdd = ({ buttonConfig, isButtonClicked }) => {
  const addHandler = buttonConfig.addHandler;
  const closeHandler = buttonConfig.closeAddModal;

  const [handleValue, handleSetValue] = useState("");

  const schema = z.object({
    item_description: z.string().nonempty(),
    short_name: z.string().nonempty(),
    unit_price: z.string().nonempty(),
    item_type: z.string(),
    active_status: z.string(),
    eff_start_date: z.string(),
    eff_end_date: z.string(),
  });

  const form = useForm({
    defaultValues: {
      status: "true",
    },
    resolver: zodResolver(schema),
  });

  const errors = form.formState.errors;

  const onSubmit = async (data) => {
    const statusValue = form.getValues("status") === "true";
    const updatedData = { ...data, status: statusValue };
    const res = await addHandler(updatedData);
    if (res) closeHandler();
  };

  const onClose = () => {
    closeHandler();
  };

  const handleKey = (e) => {
    if (e.key === "ArrowUp" || e.key === "ArrowDown") {
      e.preventDefault();
    }
  };
  return (
    <>
      <div className="fixed left-1/2 z-50 mx-auto min-h-[300px] w-[98%] max-w-[700px] -translate-x-1/2 rounded bg-white p-8 max-lg:top-[30%] max-sm:top-[10%] lg:top-1/2 lg:-translate-y-1/2">
        <h2 className="pb-4 text-2xl font-bold text-neutral-800">
          Add Pricing
        </h2>

        <button
          type="button"
          className="absolute right-8 top-8"
          onClick={onClose}
        >
          <img src={closeIcon} />
        </button>

        <form onSubmit={form.handleSubmit(onSubmit)}>
          <div className="scrollbar-custom w-full overflow-x-hidden overflow-y-scroll pr-2 max-lg:max-h-[550px] lg:max-h-[400px] ">
            {/* row 1 */}
            <div className="gap-2 sm:flex max-sm:[&>div]:mt-4">
              <div className={cn("flex w-full flex-col  gap-2")}>
                <label className="text-base text-[#636363]">
                  Item Description*
                </label>
                <input
                  placeholder="Type here"
                  {...form.register("item_description")}
                  className={cn(
                    "h-full rounded bg-neutral-100 p-2 px-2 text-[#636363] placeholder:italic focus:outline-none",
                    errors.item_description && "border-[1px] border-red-300",
                  )}
                />
              </div>

              <div className={cn("flex w-full flex-col  gap-2")}>
                <label className="text-base text-[#636363]">Short Name*</label>
                <input
                  placeholder="Type here"
                  {...form.register("short_name")}
                  className={cn(
                    "h-full rounded bg-neutral-100 p-2 px-2 text-[#636363] placeholder:italic focus:outline-none",
                    errors.short_name && "border-[1px] border-red-300",
                  )}
                />
              </div>
              <div className={cn("flex w-full flex-col  gap-2")}></div>
            </div>

            {/* row 2 */}
            <div className="gap-2 sm:mt-8 sm:flex max-sm:[&>div]:mt-4">
              <div className={cn("flex w-full flex-col  gap-2")}>
                <label className="text-base text-[#636363]">Unit Price*</label>
                <input
                  type="number"
                  step="any"
                  {...form.register("unit_price")}
                  placeholder="Type here"
                  className={cn(
                    "h-full rounded bg-neutral-100 p-2 px-2 text-[#636363] placeholder:italic focus:outline-none",
                    errors.unit_price && "border-[1px] border-red-300",
                  )}
                  onWheel={(e) => e.target.blur()}
                  onKeyDown={handleKey}
                />
              </div>

              <div className={cn("flex w-full flex-col  gap-2")}>
                <label className="text-base text-[#636363]"> Item Type</label>
                <select
                  {...form.register("item_type")}
                  className={cn(
                    "h-full rounded bg-neutral-100 p-2 px-2 text-[#636363] placeholder:italic focus:outline-none",
                    errors.item_type && "border-[1px] border-red-300",
                  )}
                >
                  <option value="">Select</option>
                  <option value="license">License</option>
                  <option value="storage">Storage</option>
                  <option value="others">Others</option>
                </select>
              </div>

              <div className={cn("flex w-full flex-col  gap-2")}>
                <label className="text-base text-[#636363]">
                  Active Status
                </label>
                <select
                  {...form.register("active_status")}
                  className={cn(
                    "h-full rounded bg-neutral-100 p-2 px-2 text-[#636363] placeholder:italic focus:outline-none",
                    errors.active_status && "border-[1px] border-red-300",
                  )}
                >
                  <option value="">Select</option>
                  <option value="active">Active</option>
                  <option value="inactive">Inactive</option>
                </select>
              </div>
            </div>

            {/* row 3 */}
            <div className=" gap-2 sm:mt-8 sm:flex sm:w-[67%] max-sm:[&>div]:mt-4">
              <div className={cn("flex w-full flex-col  gap-2")}>
                <label className="text-base text-[#636363]">
                  Eff Start Date
                </label>
                <CustomDateInput
                  handleSetValue={handleSetValue}
                  form1={form.register("eff_start_date")}
                  className="w-full rounded-[4px] bg-neutral-100"
                />
              </div>

              <div className={cn("flex w-full flex-col  gap-2")}>
                <label className="text-base text-[#636363]">Eff End Date</label>
                <CustomDateInput
                  form1={form.register("eff_end_date")}
                  handleSetValue={handleSetValue}
                  handleValue={handleValue}
                  min={form.getValues("eff_start_date")}
                  className="w-full rounded-[4px] bg-neutral-100"
                />
              </div>
            </div>
          </div>

          {/* row 4 */}

          {/* action */}
          <div className="flex items-end justify-between gap-2 sm:[&>button]:w-1/3">
            <button
              type="submit"
              disabled={isButtonClicked}
              className={` ${
                isButtonClicked ? "opacity-[70%]" : ""
              } mt-8 w-full rounded border-2 border-pri-clr-orange bg-pri-clr-orange px-16 py-2 font-semibold text-white `}
            >
              {isButtonClicked ? <MirageLoader /> : "ADD"}
            </button>
            <button className="max-lg:hidden"></button>
            <button className="max-lg:hidden"></button>
          </div>
        </form>
      </div>
      <BackDrop closeHandler={closeHandler} />
    </>
  );
};

export default MasterPriceAdd;
